import script from "./Step1PersonalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1PersonalInfo.vue?vue&type=script&setup=true&lang=js"

import "./Step1PersonalInfo.vue?vue&type=style&index=0&id=4be2dc4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be2dc4f"]])

export default __exports__